module.exports = __webpack_public_path__ + "static/img/app3.495d3014.png";